// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".gw-stat-list{display:flex;gap:var(--grid-gap-md)}.gw-stat-list__item{flex:1 1 auto}.gw-stat-list--hero{color:var(--color-gray-100)}@media screen and (min-width:769px){.gw-stat-list--hero{box-shadow:inset 0 -2px 0 var(--color-white-20);padding-bottom:var(--spacing-2xl)}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
